import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import moment from "moment"
import { capitalize, isEmpty } from "lodash"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { useLocation, useNavigate } from "react-router-dom"
import {
  downloadProjectBill,
  fetchProjectBillingReport,
} from "../../../services/finance/finance"
import { useSelector, useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/actions"
import { createSelector } from "reselect"
import ProjectBillingFilter from "./filter"
import { getTableMinWidth } from "../../../utils/getTblWdt"
import LoadingButton from "../../../components/Common/LoadingButton"

const ProjectBillingReport = ({ fromDashboard, projectId }) => {
  document.title = "Project Billing | Everise"
  const dispatch = useDispatch()
  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState(1)
  const [ccNo, setCCNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [financial, setFinancial] = useState(true)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [company, setCompany] = useState(false)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(5)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [productData, setProductData] = useState()

  const [isLoading, setIsLoading] = useState(false)

  const [tableTotalWidth, setTableTotalWidth] = useState(0)

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log("filtersdata", filters, filterLoading, filterError)

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    ) {
      setStartDate(filters?.dateFrom || "")
      setEndDate(filters?.dateTo || "")
      setProductData(filters?.productData || "")
      setSearch(filters?.search || "")
      const fetchData = async () => {
        setIsLoading(true)
        const response = await fetchProjectBillingReport({
          params: `${`account_group_id=24`}${`&cc_type=project`}${`&report_type=project_billing_report`}${
            productNo ? `&cost_center_id=${productNo}` : ""
          }${page ? `&page=${page}` : ""}${
            dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`
          }${startDate ? `&date_from=${startDate}` : ""}${
            endDate ? `&date_to=${endDate}` : ""
          }`,
        })
        // setFetchedData(response)
        const newData = response?.data || []

        setFetchedData(prev =>
          page > 1 && prev
            ? {
                ...response,
                data: [...(prev.data || []), ...newData],
              }
            : response
        )
        setIsLoading(false)
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false
        // ${`&financial=${financial}`}
      }

      //   if (
      //     filters?.dateFrom &&
      //     filters?.dateTo &&
      //     moment(filters?.dateFrom).isSameOrBefore(moment(filters?.dateTo)) &&
      //     filters?.productData
      //   ) {
      fetchData()
      //   }
    }
  }, [
    filters?.dateFrom,
    filters?.dateTo,
    filters?.productData,
    filters?.search,
  ])

  const { control, watch, reset } = useForm({
    defaultValues: {
      req_date: null,
    },
  })

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const location = useLocation()
  const navigate = useNavigate()
  const { productId, productName } = location.state || {}

  const handlePaginate = page => {
    setPage(page)
  }

  const handleCCChange = id => {
    setCCNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(
      data?.value && typeof data?.value === "object"
        ? data.id
        : data?.value
        ? data?.value
        : ""
    )
    setProductData(data)
    setPage(1)
    if (!data) {
      // Clear location.state
      navigate(location.pathname, { replace: true, state: {} })
    }
    if (data == undefined) {
      dispatch(removeFilter())
    }
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    )
      return
    const fetchData = async () => {
      setIsLoading(true)
      const response = await fetchProjectBillingReport({
        params: `${`account_group_id=24`}${`&cc_type=project`}${`&report_type=project_billing_report`}${
          productNo ? `&cost_center_id=${productNo}` : ""
        }${page ? `&page=${page}` : ""}${
          dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`
        }${startDate ? `&date_from=${startDate}` : ""}${
          endDate ? `&date_to=${endDate}` : ""
        }`,
      })
      // setFetchedData(response)
      const newData = response?.data || []
      setFetchedData(prev =>
        page > 1 && prev
          ? {
              ...response,

              data: [...(prev.data || []), ...newData],
            }
          : response
      )
      setIsLoading(false)
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
      // ${`&financial=${financial}`}
    }

    // if (
    //   datefrom &&
    //   dateto &&
    //   moment(datefrom).isSameOrBefore(moment(dateto)) &&
    //   productNo
    // ) {
    fetchData()
    // }
  }, [
    type,
    financial,
    ccNo,
    search,
    projectId,
    startDate,
    endDate,
    company,
    page,
    datefrom,
    dateto,
    productNo,
    dataPerPage,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  const loadMoreRef = useRef(null)

  useEffect(() => {
    if (!loadMoreRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0]

        if (
          target.isIntersecting &&
          !isLoadingRef.current &&
          page < fetchedData?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      },
      { threshold: 1 }
    )

    observer.observe(loadMoreRef.current)

    return () => observer.disconnect()
  }, [fetchedData, page])

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  const columns = [
    {
      label: "Documents Number",
      // renderCell: item => (item?.document_number ? item?.document_number : "-"),
      renderCell: item =>
        fromDashboard ? (
          item?.code
        ) : (
          <div
            onClick={() => {
              navigate(`/finance-voucher/view/${item?.voucher_entry_id}`, {
                state: {
                  bread: crumb,
                },
              })
              // dispatch(setFilter({refid: redData, voucherChange: voucherData, dateFrom: dateFrom, dateTo: dateTo, search: search}))
            }}
            className="pointer fw-bold"
          >
            {" "}
            {item?.document_number}{" "}
          </div>
        ),
      footerContent: () => "Total",
    },
    {
      label: "Invoice Date",
      renderCell: item =>
        item?.transaction_date
          ? moment(item?.transaction_date).format("DD-MMM-YYYY")
          : "-",
      footerContent: "",
    },
    {
      label: "Account Head",
      renderCell: item => (item?.account_head ? item?.account_head : "-"),
      footerContent: "",
    },
    {
      label: "Progress",
      renderCell: item => (item?.progress ? item?.progress : "-"),
      footerContent: tableData => {
        if (!tableData || !Array.isArray(tableData)) return <div>0%</div>

        // find the last row that has a valid progress value
        const lastValid = [...tableData]
          .reverse()
          .find(row => row?.progress !== null && row?.progress !== undefined)

        return <div>{lastValid?.progress || "0%"}</div>
      },
    },
    {
      label: <div className="text-end pe-5">Progress Amount</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.progress_amount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Advance</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.adv_amount || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Defect Liability</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.debit_amount || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Retention</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.ret_amount || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Previous Invoice</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.previous_invoice_amount || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Inv value before VAT</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.invice_val_bef_vat || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">VAT</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.vat_amount || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Net Receivable</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.net_receivable || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
    },
    {
      label: <div className="">Instrument Number</div>,
      renderCell: item => (
        <>
          {item?.against_payment?.map((dt, i) => (
            <div
              className="pointer fw-bold"
              key={`against_instrument_no_${i}`}
              onClick={() => {
                navigate(`/finance-voucher/view/${item?.voucher_entry_id}`, {
                  state: {
                    bread: crumb,
                  },
                })
                // dispatch(setFilter({refid: redData, voucherChange: voucherData, dateFrom: dateFrom, dateTo: dateTo, search: search}))
              }}
            >
              {dt?.instrument_no}
            </div>
          ))}
        </>
      ),
    },
    {
      label: <div className="">Instrument Date</div>,
      renderCell: item => (
        <>
          {item?.against_payment?.map((dt, i) => (
            <div key={`instrument_date_${i}`}>
              {moment(dt?.instrument_date).format("DD-MMM-YYYY")}
            </div>
          ))}
        </>
      ),
    },
    {
      label: <div className="text-end pe-5">Amount</div>,
      renderCell: item => (
        <>
          {item?.against_payment?.map((dt, i) => (
            <div className="text-end pe-5" key={`against_${i}`}>
              {NumberFormat(
                Number(dt?.amount || 0),
                desimalrange,
                desimalrange
              )}
            </div>
          ))}
        </>
      ),
    },
    // {
    //   label: <div className="text-end pe-5">Outstanding</div>,
    //   renderCell: item => (
    //     <>
    //       <div className="text-end pe-5 text-danger">
    //         {NumberFormat(
    //           Number(item?.net_receivable || 0) -
    //             Number(item?.against_payment[0]?.amount),
    //           desimalrange,
    //           desimalrange
    //         )}
    //       </div>
    //     </>
    //   ),
    // },
    {
      label: <div className="text-end pe-5">Outstanding</div>,
      renderCell: item => {
        const a = Number(item?.net_receivable || 0)

        let runningTotal = 0

        return (
          <>
            {item?.against_payment?.map((dt, i) => {
              runningTotal += Number(dt?.amount || 0) // add previous + current

              return (
                <div className="text-end pe-5 text-danger" key={`against_${i}`}>
                  {NumberFormat(
                    a - runningTotal, // a - (b1 + b2 + ... + current)
                    desimalrange,
                    desimalrange
                  )}
                </div>
              )
            })}
          </>
        )
      },
    },
  ]

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleReset = () => {
    reset({ req_date: null })
    setStartDate("")
    setEndDate("")
  }

  const handleCompanyChange = id => {
    setCompany(id)
    setPage(1)
  }

  const totalAgainstPayment = (voucherEntries = []) => {
    return voucherEntries?.reduce((sum, entry) => {
      const innerSum = (entry?.against_payment || []).reduce(
        (acc, ap) => acc + Number(ap?.amount || 0),
        0
      )
      return sum + innerSum
    }, 0)
  }

  const handleDateChange = (fromdate, todate) => {
    setStartDate(fromdate)
    setEndDate(todate)
    setPage(1)
    setDataPerPage(25)
  }

  const totalNetReceivable = (voucherEntries = []) => {
    return voucherEntries?.reduce(
      (sum, entry) => sum + Number(entry?.net_receivable || 0),
      0
    )
  }

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb || "Reports", link: "#" },
                  {
                    title: "Project Billing Report",
                    link: "#",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectBill({
                        params: `export_format=pdf&account_group_id=24&cc_type=project${`&report_type=project_billing_report`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&date_from=${startDate}` : ""}${
                          endDate ? `&date_to=${endDate}` : ""
                        }`,
                        type: "pdf",
                        fileName: "project_billing.pdf",
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectBill({
                        params: `export_format=excel&account_group_id=24&cc_type=project${`&report_type=project_billing_report`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&date_from=${startDate}` : ""}${
                          endDate ? `&date_to=${endDate}` : ""
                        }`,
                        type: "excel",
                        fileName: "project_billing.xlsx",
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>

          <Card
            className={`me-2 px-2 pb-2 ${fromDashboard ? "dash-table-bg" : ""}`}
          >
            {fromDashboard ? (
              <div className="px-2 py-3">Transaction History</div>
            ) : (
              <ProjectBillingFilter
                // handleCCChange={handleCCChange}
                handleTypeChange={handleTypeChange}
                handleSearchChange={handleSearchChange}
                handleDateChange={handleDateChange}
                handleProductChange={handleProductChange}
                handleFinacialChange={handleFinacialChange}
                handleCompanyChange={handleCompanyChange}
                resetData={{
                  fromData: datefrom,
                  toData: dateto,
                  productData: productData,
                  search: search,
                }}
                {...(location?.state && {
                  productId,
                  productName,
                })}
              />
            )}
            <hr className="table-divide" />
            <div>
              {fromDashboard && (
                <Row className="pt-2">
                  <Col sm={6}>
                    <UFDate
                      control={control}
                      placeholder="Date"
                      name={"req_date"}
                      mode="range"
                      className="ufinput-dashboard"
                      onDateChange={e => handleRequestdate(e)}
                    />
                  </Col>
                  <Col sm={3}></Col>
                  <Col sm={3}>
                    <div
                      className="pointer me-2 text-white btn btn-primary float-end"
                      onClick={() => handleReset()}
                    >
                      <img
                        src={resetIcon}
                        height={15}
                        width={15}
                        className="me-2 svg-clr-reset"
                      />{" "}
                      Reset
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className={`ever-rise-table ${
                  fromDashboard ? "dashboardTable" : ""
                } `}
              >
                <Col xs={12}>
                  {fetchedData?.data?.length ? (
                    <div
                      ref={tableContainerRef}
                      style={{ maxHeight: "490px", overflowY: "auto" }}
                    >
                      {fetchedData?.data?.map((data, i) => (
                        <>
                          <div className="d-flex justify-content-between px-2 py-3 fw-600 cost-center-bar">
                            <div>
                              Project Name: {data?.cost_center_name || ""}
                            </div>
                            <div>
                              Project Value:{" "}
                              {NumberFormat(
                                Number(data?.projectAmount || 0),
                                desimalrange,
                                desimalrange
                              )}{" "}
                            </div>
                          </div>

                          <UpdateTable
                            className="mt-5"
                            nodes={data?.VoucherEntries}
                            paginate={fetchedData}
                            columns={columns}
                            CurrentPage={page}
                            handlePagination={handlePaginate}
                            handleSizePerPage={handleSizePerPageChange}
                            tableWidth="20% 15% 30% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% 15% "
                            mobileWidth="50% 50% 50% 50%"
                            isLoading={isLoadingNextPage}
                            hidePaginate={true}
                          />
                          <div
                            className="d-flex fw-600 py-2"
                            style={{ minWidth: "259%" }}
                          >
                            <div className="wdt-20 ps-2">Total</div>
                            <div className="wdt-15"></div>
                            <div className="w-30"></div>
                            <div className="wdt-15 ps-4">
                              {data?.VoucherEntries[
                                data?.VoucherEntries?.length - 1
                              ]?.progress || "0%"}
                            </div>
                            <div className="wdt-15 text-end pe-5">
                              {NumberFormat(
                                Number(
                                  data?.VoucherEntries[
                                    data?.VoucherEntries?.length - 1
                                  ]?.progress_amount || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15 text-end pe-5">
                              {NumberFormat(
                                Number(
                                  totalNetReceivable(data?.VoucherEntries) || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15"></div>
                            <div className="wdt-15 text-end pe-2">
                              {NumberFormat(
                                Number(
                                  totalAgainstPayment(data?.VoucherEntries) || 0
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                            <div className="wdt-15 text-end pe-2 text-danger">
                              {NumberFormat(
                                Number(
                                  totalNetReceivable(data?.VoucherEntries) || 0
                                ) -
                                  Number(
                                    totalAgainstPayment(data?.VoucherEntries) ||
                                      0
                                  ),
                                desimalrange,
                                desimalrange
                              )}
                            </div>
                          </div>
                          {/* </div> */}
                        </>
                      ))}
                      {page < fetchedData?.meta?.last_page && (
                        <div
                          className="cost-center-bar d-flex justify-content-center mb-2"
                          // ref={loadMoreRef}
                        >
                          <LoadingButton
                            color="primary"
                            onClick={() => setPage(prev => prev + 1)}
                            loading={isLoading}
                          >
                            Load More
                          </LoadingButton>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex mt-5 justify-content-center align-items-center fw-bold text-mute">
                      No Data Found
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectBillingReport
